import api from '../lib/api'

export const updateProfile = (body) =>
  api.patch('/manager/auth/me', body).then(r => r.data)

export const changePassword = (body) =>
  api.patch('/manager/auth/me/password', body).then(r => r.data)

export const updateBusiness = (tenantId, body) =>
  api.patch(`/manager/${tenantId}/business`, body).then(r => r.data)

export const uploadAvatar = (file) => {
  const form = new FormData()
  form.append('file', file)
  return api.post('/manager/auth/me/avatar', form).then(r => r.data)
}

export const deleteAvatar = () =>
  api.delete('/manager/auth/me/avatar').then(r => r.data)
